import { useGetHelpCenterCategories } from 'app/services/Query/help-center/help-center.query'
import { HELP_CENTER_CATEGORY_PARAMS } from 'app/utils/constants/help-center.constants'

interface UseGetCategoriesNameProps {
  categorySlug: string
}

export const useGetCategoriesData = ({
  categorySlug
}: UseGetCategoriesNameProps) => {
  const { data: categories } = useGetHelpCenterCategories({
    params: HELP_CENTER_CATEGORY_PARAMS,
    options: { enabled: false }
  })

  const category = categories?.find((el) => el.slug === categorySlug)
  const categoryBySubcategory = categories?.find((el) =>
    el?.sub_categories?.find((el) => el.slug === categorySlug)
  )
  const subcategory = categoryBySubcategory?.sub_categories?.find(
    (el) => el.slug === categorySlug
  )

  const categoryName = category?.name ?? categoryBySubcategory?.name
  const subcategoryName = subcategory?.name
  const currentCategorySlug = category?.slug ?? categoryBySubcategory?.slug
  const currentSubcategorySlug = subcategory?.slug

  return {
    categoryName,
    subcategoryName,
    currentCategorySlug,
    currentSubcategorySlug
  }
}
